// src/components/BookingFlowWrapper.jsx
"use client";
import React from "react";
import BookingFlow from "./BookingFlow";

export default function BookingFlowWrapper() {
  // Always show BookingFlow - no auth check on /book page
  // Authentication will be required when user reaches /book/confirm
  return <BookingFlow />;
}
